<template>
  <div
    ref="sf"
    class="sf"
  >
    <label
      v-show="title"
      class="sf-label"
    >
      {{ title }} <span v-show="!required">(Optional)</span>
    </label>
    <div class="sfi-container">
      <input
        class="sfi"
        :disabled="disabled"
        :id="`${title}-input-id`"
        :name="`${title}-input-name`"
        :placeholder="placeholder"
        @focus="checkInputFocus"
        v-model="inputValue"
        @change="updateInputValue"
        @blur="setInputValue"
        @input="checkInputTouched"
      >
      <svg
        v-show="!withoutIcon"
        class="sfi-icon"
        width="9"
        height="6"
        viewBox="0 0 9 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99977 1.28394L4.56677 4.71594L1.13477 1.28394"
          stroke="#8EC63E"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      v-show="isOpened && filteredOptions.length"
      class="sf-content"
    >
      <ul class="sf-list">
        <li
          v-for="(option) in filteredOptions"
          :key="option.value"
          :class="['sf-list-item', (option.value === currentValue) && 'sf-list-item-selected']"
          @click="selectItem(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>

    <p
      v-show="description"
      class="sf-desc"
    >
      {{ description }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'SelectField',
  props: {
    title: {
      type: String,
    },
    placeholder: {
      type: String,
      required: false,
    },
    description: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    withoutIcon: {
      type: Boolean,
    },
    options: {
      type: Array,
    },
    value: {
      type: Object,
      required: false,
    },
    disableFocus: {
      type: Boolean,
      required: false,
    },
    withAllOptions: {
      type: Boolean,
      required: false,
    },
    valueOnlyFromOptions: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isOpened: false,
      inputValue: '',
      currentValue: '',
      selectedResult: '',
      isInputTouched: false,
    };
  },
  watch: {
    inputValue(newValue) {
      if (this.disableFocus && newValue.length === 0) {
        this.isOpened = false;
        this.isInputTouched = false;
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    this.inputValue = this.value ? this.value.label : '';
    this.currentValue = this.value ? this.value.value : '';
  },
  methods: {
    checkInputTouched() {
      this.isOpened = true;
      if (this.withAllOptions) {
        if (this.inputValue !== this.selectedResult) {
          this.isInputTouched = true;
        }
      }
    },
    checkInputFocus() {
      if (!this.disableFocus) {
        this.isOpened = true;
      }

      if (this.withAllOptions) {
        this.selectedResult = this.inputValue;
      }
    },
    selectItem(option) {
      this.isOpened = false;
      this.isInputTouched = false;
      this.inputValue = option.label;
      this.currentValue = option.value;
      this.$emit('input', option);
    },
    handleClickOutside(event) {
      if (
        this.$refs.sf
              && !this.$refs.sf.contains(event.target)
      ) {
        this.isOpened = false;
        this.isInputTouched = false;
      }
    },
    getResult(event) {
      const { value } = event.target;
      let result = null;
      if (value && this.filteredOptions.length === 1) {
        [result] = this.filteredOptions;
      }

      return result;
    },
    updateInputValue(event) {
      this.$emit('input', this.getResult(event));
      if (!this.valueOnlyFromOptions) {
        this.$emit('inputCustom', event.target.value);
      }
    },
    setInputValue(event) {
      const result = this.getResult(event);
      if (result) {
        this.inputValue = result.label;
        this.currentValue = result.value;
      }
    },
  },
  computed: {
    isFieldEditedWhileOpen() {
      if (this.isOpened) {
        if ((this.inputValue === this.selectedResult) && !this.isInputTouched) {
          return false;
        }
        return true;
      }
      return false;
    },
    filteredOptions() {
      const filter = this.inputValue ? this.options
        .filter((option) => option
          .label?.toLowerCase().startsWith(this.inputValue.toLowerCase())
          || option.search?.toLowerCase().startsWith(this.inputValue.toLowerCase())) : this.options;

      if (this.withAllOptions) {
        if (this.isFieldEditedWhileOpen) {
          return filter;
        }
        return this.options;
      }
      return filter;
    },
  },
};
</script>
